import {defineNuxtPlugin} from '#app';
import {createLogger} from '../loggerFactory';

export default defineNuxtPlugin({
    name: 'logger',
    setup(nuxtApp) {
        const logger = createLogger(nuxtApp.ssrContext?.event);
        return {
            provide: {
                logger,
            },
        };
    },
});
